import React from 'react';
import { fmtEtaClock } from './chargeUi';

interface Props {
  goal: number | null;        // applied charge goal %
  etaHours: number | null;    // longest time-to-goal across batteries
  goalMixed?: boolean;        // chargers disagree on goal (aggregate only)
}

/** A single metric tile — small uppercase label over a big monospace value.
 *  Mirrors the charger app's .metric-box. */
function MetricBox({ label, warn, children }: { label: string; warn?: boolean; children: React.ReactNode }) {
  return (
    <div className="text-center px-3 py-1 min-w-[84px]">
      <div className="text-[0.65rem] font-semibold tracking-[0.12em] text-on-surface-variant uppercase mb-0.5">{label}</div>
      <div className={`text-2xl font-bold font-mono tabular-nums leading-tight whitespace-nowrap ${warn ? 'text-amber-400' : 'text-white'}`}>
        {children}
      </div>
    </div>
  );
}

/** GOAL · ETA metric row (charger-app style), separated by an amber divider. */
export default function ChargeMetrics({ goal, etaHours, goalMixed }: Props) {
  return (
    <div className="flex items-stretch justify-center gap-1">
      <MetricBox label="GOAL" warn={goalMixed}>
        {goal != null
          ? <>{goal}<small className="text-[0.7em] font-semibold align-baseline">%</small></>
          : '—'}
      </MetricBox>
      <div className="w-px self-stretch my-1 bg-primary/40" aria-hidden="true" />
      <MetricBox label="ETA">{fmtEtaClock(etaHours)}</MetricBox>
    </div>
  );
}
